var map = {
	"./apple.png": "/Q+0",
	"./bg_light.png": "h/az",
	"./cash.png": "aY0Y",
	"./chalkboard.png": "McFu",
	"./credit.png": "dsP8",
	"./google.png": "U+UR",
	"./hungry.png": "zRXc",
	"./pensive.png": "MxEr",
	"./pizza_header.jpg": "eeKX",
	"./style-v2.css": "eAeF",
	"./style.css": "Ltvu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5izo";